import { get, post } from './axios.js'

/**
 * 레포트 CashFlow 입금(Y,N) - 출금(Y,N) 리스트 - /monthly/getCashFlowList
 * @param {object} params
 * @property {string} params.fs_year
 * @returns
 */
export async function getCashFlowList(params = {}) {
  try {
    const result = await post('/monthly/getCashFlowList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 영업대표 목록 - /monthly/getLoadUsers
 * @returns
 */
export async function getLoadUsers(params = {}) {
  try {
    const result = await post('/monthly/getLoadUsers',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * - /monthly/getMrGmHeaderList
 * @returns
 */
export async function getMrGmHeaderList(params) {
  try {
    const result = await post('/monthly/getMrGmHeaderList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * - /monthly/getMrGmList
 * @returns
 */
export async function getMrGmList(params) {
  try {
    const result = await post('/monthly/getMrGmList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * - /monthly/getPaymentList
 * @param {object} params
 * @property {string} params.fs_yearMM 일자 ex 20240601
 * @returns
 */
export async function getPaymentList(params={}) {
  try {
    const result = await post('/monthly/getPaymentList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * - /monthly/getPipeLine_HygieneLIST
 * @param {object} params
 * @property {string} params.fs_year 년도 ex 2024
 * @returns
 */
export async function getPipeLine_HygieneLIST(params={}) {
  try {
    const result = await post('/monthly/getPipeLine_HygieneLIST', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}


/**
 * - /monthly/getPipeLine_HygieneSalesLIST
 * @param {object} params
 * @property {string} params.fs_year 올해 년도 ex 2024
 * @property {string} params.fs_year_1 다음 년도 ex 2025
 * @property {string} params.employee_id 
 * @returns
 */
export async function getPipeLine_HygieneSalesLIST(params={}) {
  try {
    const result = await post('/monthly/getPipeLine_HygieneSalesLIST', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * - /monthly/getPerformanceFCSTList
 * @returns
 */
export async function getPerformanceFCSTList(params={}) {
  try {
    const result = await post('/monthly/getPerformanceFCSTList',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * - /monthly/getPipeLine_HygieneDtlLIST
 * @params
 * @property {string} params.type case 타입 
 * @property {string} params.user_id 사번
 * @returns
 */
export async function getPipeLine_HygieneDtlLIST(params={}) {
  try {
    const result = await post('/monthly/getPipeLine_HygieneDtlLIST',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * - /monthly/getPaymentListUpdate
 * @param {object} params
 * @property {string} params.fs_yearMM 일자 ex 20240601
 * @returns
 */
export async function getPaymentListUpdate(params={}) {
  try {
    const result = await post('/monthly/getPaymentListUpdate', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * - /monthly/getPaymentListUpdate
 * @param {object} params
 * @property {string} params.fs_yearMM 일자 ex 20240601
 * @returns
 */
export async function getPerformanceTotalList(params={}) {
  try {
    const result = await post('/monthly/getPerformanceTotalList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}
